<div class="col-xl provider-list-wrap">
    <div class="provider-list-header">
        <div>
            <h4 class="provider-list-title">Proveedores</h4>
            <p class="provider-list-subtitle">Consulta y administra el catálogo de proveedores.</p>
        </div>
        <div class="provider-list-actions">
            <div class="provider-search">
                <img src="assets/img/provider/icon-search.svg" alt="" width="20" height="20">
                <input type="text" placeholder="Buscar proveedor..." [(ngModel)]="filterText" (ngModelChange)="onSearchChange()">
            </div>
            <a class="btn-new-provider" routerLink="/provider/add" *ngIf="canDo('Proveedores','Crear')">
                + Nuevo proveedor
            </a>
        </div>
    </div>

    <div class="provider-table-card">
        <ag-grid-angular class="ag-theme-alpine provider-grid" style="width: 100%;" [domLayout]="'autoHeight'"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true"
            [rowHeight]="62" [headerHeight]="44"
            [pagination]="true" [paginationPageSize]="perPage" [suppressPaginationPanel]="true"
            [loadingCellRenderer]="loadingCellRenderer" [loadingCellRendererParams]="loadingCellRendererParams"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [suppressCellFocus]="true"
            (gridReady)="onGridReady($event)" (paginationChanged)="onPaginationChanged()"></ag-grid-angular>

        <div class="provider-pagination-bar" *ngIf="rowData.length > 0">
            <span class="provider-pagination-label">{{paginationRangeLabel}}</span>
            <div class="provider-pagination" *ngIf="lastPage > 1">
                <button type="button" class="provider-pagination-arrow" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"><img src="assets/img/departure-check/icon-pagination-prev.svg" alt=""></button>
                <button type="button" class="provider-pagination-page" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                <button type="button" class="provider-pagination-arrow" [disabled]="currentPage === lastPage" (click)="goToPage(currentPage + 1)"><img src="assets/img/departure-check/icon-pagination-next.svg" alt=""></button>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
